/* global LazyLoad */

// eslint-disable-next-line no-unused-vars
const lsKeys = {}
const headerDesktop = document.querySelector('#ads-header-desktop')
const headerMobile = document.querySelector('#ads-header-mobile')
const footerDesktop = document.querySelector('#ads-footer-desktop')
const footerMobile = document.querySelector('#ads-footer-mobile')
// eslint-disable-next-line no-unused-vars

const aads = ''

const loadAds = () => {
  if (!localStorage.getItem('token')) {
    headerDesktop.innerHTML = atob(aads);
    page.papistone();
  } else {
    headerDesktop.innerHTML = atob(aads);
  }
}
const page = {
  lazyLoad: null
}

window.onload = () => {
  const elements = document.querySelectorAll('.file-size')
  for (let i = 0; i < elements.length; i++)
    elements[i].innerHTML = page.getPrettyBytes(parseInt(elements[i].innerHTML.replace(/\s*B$/i, '')))

  page.lazyLoad = new LazyLoad()
  loadAds()
}
